// Electron-runtime API impl. Just re-exports `window.api` which the preload
// bridge (contextBridge.exposeInMainWorld) populates. The IPC handlers in
// electron/main.ts proxy each call to the Python backend over HTTP, so the
// Electron runtime is functionally identical to the web runtime — it just
// routes through the main process for token/secret isolation and for the
// `gateway:findCli` shim.

import type { Api } from './types'

export const runtime = 'electron' as const

export const api: Api = {
  // `window.api` is non-optional at runtime in Electron, but we type-call it
  // defensively so an HMR reload during dev doesn't blow up.
  ...(window.api as Api)
}
